"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShades = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _queriesNet = require("../../queries-net");
var _utils = require("../../utils");
var _hooks = require("../RevieveVirtualTryOnPDP/hooks");
/* istanbul ignore file @preserve -- api */

const useShades = () => {
  const {
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    headers
  } = (0, _presentationHttp.useHeaders)();
  const productCode = (0, _hooks.useProductCode)();
  const {
    data
  } = (0, _fetching.useGraphqlQuery)({
    query: _queriesNet.productShadesQuery,
    url: graphQlNetUrl,
    headers,
    variables: {
      productCode: productCode ?? ''
    },
    skip: !productCode || !isUserVerified,
    swrConfig: (0, _presentationUtils.getRetryErrorSwrOptions)()
  });
  return (0, _react.useMemo)(() => (0, _utils.mapShades)({
    data,
    productCode
  }), [data, productCode]);
};
exports.useShades = useShades;
